import React, {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {KTIcon} from '@/_metronic/helpers'

type StatusCellProps = {
  status: string
}

const SaleStatusCell: FC<StatusCellProps> = ({status}) => {
  const intl = useIntl()

  return (
    <div className={clsx('badge', {
      'badge-light-primary': status === 'PENDING',
      'badge-light-success': status === 'SUCCEED',
      'badge-light-danger': status === 'CANCELLED'
    })}>
      {intl.formatMessage({id: `P2C.ORDER_STATUS_${status}`})}
    </div>
  )
}

type ProductCellProps = {
  product: string
  gift?: {
    email: string
    message?:string
  }
}

const SaleProductCell: FC<ProductCellProps> = ({product, gift}) => {
  return (
    <div>
      {product}
      {gift && (
        <span className="ps-3" title={gift.email}>
          <KTIcon
            iconName='gift'
            className="fs-1 text-primary"
          />
        </span>
      )}
    </div>
  )
}

export {
  SaleStatusCell,
  SaleProductCell
}
